import Icon from '@material-ui/icons/Timelapse';
import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import { ResourceList, ResourceShow } from '../../../controllers';
import { DateField, DateTimeField, EnumField, LinkField, TextField } from '../../../fields';

// shopify and recharge are the source of truth for subscriptions, so platform has no subscription to
// create here, and nothing Houston edits
export default {
  Icon,
  dialogs: {
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <LinkField
          label="Child"
          parentReference="organizations"
          parentSource="organization_id"
          reference="users"
          source="user_id"
        />
        <EnumField
          source="tier"
        />
        <EnumField
          source="status"
        />
        <EnumField
          source="cadence"
        />
        <DateTimeField
          source="created_at"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="id"
        />
        <LinkField
          label="Child"
          parentReference="organizations"
          parentSource="organization_id"
          reference="users"
          source="user_id"
        />
        <EnumField
          source="tier"
        />
        <EnumField
          source="status"
        />
        <EnumField
          source="cadence"
        />
        <TextField
          source="price"
        />
        <DateField
          label="Next Bill Date"
          source="next_charge_on"
        />
        <DateTimeField
          source="next_coin_grant_at"
        />
        <DateTimeField
          source="created_at"
        />
      </ResourceShow>
    ),
  },
  components: {
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >
        <TextField
          source="id"
        />
        <DateTimeField
          source="next_coin_grant_at"
        />
      </SimpleShowLayout>
    ),
  },
  resources: {
  },
};
